import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import BackgroundCategory from '../../../domain/entities/BackgroundCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetBackgroundCategoriesRepository from '../../../data/repositories/NetBackgroundCategoriesRepository';

const types = {
  failure: Types.IndexBackgroundCategoriesFailure,
  request: Types.IndexBackgroundCategoriesRequest,
  success: Types.IndexBackgroundCategoriesSuccess,
};

export interface Params extends BaseParams {
  id?: number | null;
  parentId?: number | null;
}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<BackgroundCategory>> {
  return indexGenerics(new NetBackgroundCategoriesRepository(), types, params);
}
